import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { UserSessionService } from 'src/app/services/usersession.service';
@Component({
    selector: 'app-portal-list-shared',
    templateUrl: './portal-list-shared.component.html',
    styleUrls: ['./portal-list-shared.component.scss'],
    standalone: false
})

export class PortalListSharedComponent implements OnInit {
  @Input() section;
  @Input() callScriptFields = [];

  FieldType = 'Login Id'
  selectAllCheckbox = false;
  @Input() tenantId: number;
  @Input() moduleType = 0;
  @Input() customerName: any;
  @Input() disablePasswordReset: boolean = false;
  masterLoginList: any = [];
  public loaderIcon: Promise<boolean>;
  update: boolean = false;
  ResetPassword: boolean = false;
  disableResetPassword: boolean = false;
  @Input() set setPortalList(value) {
    if (value && value.length) {
      value.forEach((ele) => {
        if (ele && ele.Selected == undefined) {
          if (this.moduleType == 1) {
            ele['Selected'] = true;
          } else if (this.moduleType == 2) {
            ele['Selected'] = false;
          }

        }
        if (ele && ele.Edit == undefined) {
          ele['Edit'] = false;
        }
      if (ele.CreatedDateTime) {
        ele.CreatedDateTime = this.formatAsLocalString(ele.CreatedDateTime);
      }
      });
      this.masterLoginList = JSON.parse(JSON.stringify(value));
      this.portalLoginList = value;
    } else {
      this.masterLoginList = [];
      this.portalLoginList = [];
    }
    this.onSelectEachRecord();
  };

  @Output() emitSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitReset: EventEmitter<any> = new EventEmitter<any>();
  isFormEdit: boolean = false;
  @ViewChild('PortalLoginInfoModal', { static: true }) PortalLoginInfoModal: ModalDirective;
  @ViewChild('DeleteAlertModal', { static: true }) DeleteAlertModal: ModalDirective;
  @ViewChild('AddAlertModal', { static: true }) AddAlertModal: ModalDirective;
  @ViewChild('ConfirmationModal', { static: true }) ConfirmationModal: ModalDirective;
  PortalLoginItemId: Subject<any> = new Subject();
  portalForm: UntypedFormGroup;
  portalLoginList = [];
  emailIdsPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
  isDuplicateEntry: boolean = false;
  isDuplicateEntryEmailId: boolean = false;
  existingauthenticationId = '0';
  portalPageDirty = false;
  recordText = 'Record';
  existingAccountInfo = null;
  isLoginIdValidEmailId = false
  checkedLoginId = '';
  checkedEmailId = '';
  disableForExisting: boolean = false;
  loginIdPattern = "\\S*";
  isLoginExistsChecked = false;
  isEmailExistsChecked = false;
  isAddClicked = false;

  constructor(
    public formBuilder: FormBuilder,
    private prospectService: ProspectService,
    private userSessionService: UserSessionService,
  ) { }

  ngOnInit() {
    this.portalForm = this.formBuilder.group({
      Id: [''],
      FirstName: ['', [Validators.required, Validators.pattern(/\S+/)]],
      LastName: ['', [Validators.required, Validators.pattern(/\S+/)]],
      LoginId: ['', [Validators.required, Validators.pattern(this.loginIdPattern)]],
      EmailId: ['', [Validators.pattern(this.emailIdsPattern)]],
      CreatedDateTime:[null as string | null]
    });
    this.PortalLoginItemId.pipe(debounceTime(800),distinctUntilChanged()).subscribe(event => {
      this.ValidatePortalLoginItem(1);
    });
  }

  clearValidationParameterOnLoad() {
    this.isDuplicateEntry = false;
    this.isDuplicateEntryEmailId = false;
    this.existingauthenticationId = '0';
    this.portalPageDirty = false;
    this.existingAccountInfo = null;
    this.isLoginIdValidEmailId = false
    this.checkedLoginId = '';
    this.checkedEmailId = '';
    this.disableForExisting = false;
    this.isLoginExistsChecked = false;
    this.isEmailExistsChecked = false;
    this.isAddClicked = false;
    this.isFormEdit = false;
    this.disableResetPassword = false;
  }
  addItemToGrid(event: Event) {
    event.preventDefault();
    this.isAddClicked = true;
    this.disableResetPassword = true;
    this.ValidatePortalLoginItem(2);
  }

  savePortalItem() {
    this.isAddClicked = false;
    this.disableForExisting = false;
    this.portalForm.controls['EmailId'].enable();
    let sel = true;
    if (this.moduleType == 2) {
      sel = false;
    }
    let emailId = this.portalForm.get('EmailId').value;
    if (this.checkValidEmail()) {
      emailId = this.portalForm.get('LoginId').value;
    }
    let obj = {
      Id: -1 * Math.random(),
      TenantId: this.tenantId,
      FirstName: this.portalForm.get('FirstName').value,
      LastName: this.portalForm.get('LastName').value,
      UserName: this.portalForm.get('LoginId').value,
      AuthenticationId: !this.existingauthenticationId || this.existingauthenticationId == "0" ?
        null : this.existingauthenticationId,
      EmailId: emailId ? emailId.trim() : emailId,
      DeleteFlag: false,
      Edit: true,
      Selected: sel,
      Update: this.update,
      ResetPassword: this.ResetPassword,
      NewAccount: this.disableResetPassword,
    }

    this.portalLoginList.push(obj);
    this.portalForm.reset();
    this.existingauthenticationId = '0';
    this.onSelectEachRecord();
    this.portalPageDirty = true;
  }

  editRecord(obj, eve) {
    if (eve && eve.target && (eve.target.tagName !== 'INPUT'
      && eve.target.tagName !== 'SPAN' && eve.target.tagName !== 'LABEL')) {
      this.isFormEdit = true;
      this.portalForm.patchValue({
        Id: obj.Id,
        FirstName: obj.FirstName,
        LastName: obj.LastName,
        LoginId: obj.UserName,
        EmailId: obj.EmailId,
        CreatedDateTime: obj.CreatedDateTime
      });
    }
  }

  updatePortalItem() {
    let obj = this.portalLoginList.find(o => o.Id == this.portalForm.get('Id').value);
    if (obj) {
      obj.FirstName = this.portalForm.get('FirstName').value;
      obj.LastName = this.portalForm.get('LastName').value;
      obj['Edit'] = true;
    }
    this.isFormEdit = false;
    this.portalForm.reset();
    this.onSelectEachRecord();
    this.portalPageDirty = true;
  }

  portalLoginPasswordReset() {
    let obj = this.portalLoginList.find(o => o.Id == this.portalForm.get('Id').value);
    if (obj) {
      obj['ResetPassword'] = true;
      obj['NewAccount'] = true;
    }
    this.emitReset.emit(this.portalLoginList);
  }

  selectAllRecords(eve) {
    if (eve && eve.target.checked) {
      this.portalLoginList.forEach((ele) => {
        ele.Selected = true;
        ele.DeleteFlag = false;
      });
    } else {
      this.portalLoginList.forEach((ele) => {
        ele.Selected = false;
        ele.DeleteFlag = true;
      });
    }
  }

  onSelectEachRecord() {
    if (this.portalLoginList.length && this.portalLoginList.every(item => item.Selected)) {
      this.selectAllCheckbox = true;
    } else {
      this.selectAllCheckbox = false;
    }
  }

  savePortalLogin() {
    this.emitSave.emit(this.portalLoginList);
    this.masterLoginList = JSON.parse(JSON.stringify(this.portalLoginList));
  }

  cancelPortalLogin() {
    this.portalLoginList = this.masterLoginList;
    this.portalForm.reset();
    this.emitCancel.emit(this.masterLoginList);
    this.isFormEdit = false;
    this.disableForExisting = false;
    this.isDuplicateEntry = false;
    this.isDuplicateEntryEmailId = false;
  }

  checkIfDelete() {
    if (this.portalLoginList && this.portalLoginList.length) {
      let arr = this.portalLoginList.filter((ele) => ele.Selected == true);
      if (arr.length) {
        return false;
      }
    }
    return true;
  }

  showDeletePopup() {
    if (this.portalLoginList.filter((ele) => ele.Selected).length > 1) {
      this.recordText = 'Records';
    } else {
      this.recordText = 'Record';
    }
    this.DeleteAlertModal.show();
  }

  deletePortalList() {
    if (this.portalLoginList.length) {
      this.portalLoginList.forEach((ele, i) => {
        if (ele && ele.Selected) {
          if (ele.Id < 0) {
            this.portalLoginList.splice(i, 1);
          } else {
            ele.DeleteFlag = true;
            ele['Edit'] = true;
          }
        }
      });
    }
    this.isFormEdit = false;
    this.portalForm.reset();
    if (this.portalLoginList.length && this.portalLoginList.filter((item) => item.DeleteFlag).length) {
      this.emitDelete.emit(this.portalLoginList);
    }
    this.DeleteAlertModal.hide();
    this.portalPageDirty = true;
  }

  showAddPopup() {
    this.AddAlertModal.show();
  }

  isValidEmail() {
    if (this.portalForm.get('LoginId').value) {
      let chk = this.checkValidEmail();
      if (chk) {
        this.portalForm.get('EmailId').setValidators(null);
        this.portalForm.get('EmailId').updateValueAndValidity();
      } else {
        this.addValidationsEmail();
      }
      return !chk;
    }
    return true;
  }

  clearPortalForm() {
    this.portalForm.reset();
    this.isDuplicateEntry = false;
    this.isDuplicateEntryEmailId = false;
    this.existingauthenticationId = '0';
  }

  ValidatePortalLoginItem(fieldType) {
    this.isLoginIdValidEmailId = false;
    this.loaderIcon = Promise.resolve(true);
    let loginOrEmail = '';
    if (fieldType == 1) {
      this.isLoginExistsChecked = false;
      loginOrEmail = this.portalForm.get('LoginId').value;
    } else {
      this.isEmailExistsChecked = false;
      loginOrEmail = this.portalForm.get('EmailId').value;
    }
    let loginOrEmailObj = {
      EmailId: loginOrEmail
    }
    let chk = this.checkValidEmail();
    if (chk) {
      this.isLoginIdValidEmailId = true;
    }
    if (loginOrEmail && loginOrEmail.trim() !== '' &&
      (fieldType == 1 || (fieldType == 2 && (!this.portalForm.get('EmailId').errors && !this.portalForm.get('EmailId').errors?.pattern)))) {
      this.checkEmailExists(loginOrEmailObj, fieldType);
    } else {
      this.isDuplicateEntry = false;
      this.isDuplicateEntryEmailId = false
      if (this.isAddClicked) {
        this.savePortalItem();
      }
      this.loaderIcon = Promise.resolve(false);
    }
  }

  checkEmailExists(emailObjLoginId: any, fieldType) {
    this.prospectService.CheckTenantEmailB2CAccountExists(emailObjLoginId).subscribe(
      (response) => {
        if (response.Exists) {
          if (fieldType == 1) {
            this.isDuplicateEntry = true;
          } else {
            this.existingauthenticationId = '0';
            this.isDuplicateEntryEmailId = false;
            this.existingAccountInfo = response;
            this.FieldType = 'Email Id';
            let emailExisting: string;
            if (this.existingAccountInfo.hasOwnProperty('Username') && emailObjLoginId.EmailId == this.existingAccountInfo.Username) {
              emailExisting = this.existingAccountInfo.Username;
            } else {
              emailExisting = this.existingAccountInfo.hasOwnProperty('Email') ? this.existingAccountInfo.Email : this.existingAccountInfo.AlternateEmail;
            }
            this.checkLoginOrEmailInList(emailExisting, 2, true);
          }
          this.loaderIcon = Promise.resolve(false);
        } else {
          this.checkLoginOrEmailInList(emailObjLoginId.EmailId, fieldType, false);
        }
        if (fieldType == 1) {
          if (this.isLoginIdValidEmailId) {
            this.portalForm.patchValue({
              EmailId: this.portalForm.get('LoginId').value
            });
            this.portalForm.controls['EmailId'].disable();
            this.ValidatePortalLoginItem(2);
          } else {
            this.isAddClicked = false;
            this.portalForm.controls['EmailId'].enable();
          }
        }
      },
      (err) => {
        this.checkLoginOrEmailInList(emailObjLoginId.EmailId, fieldType, false);
      }
    );
  }

  checkValidEmail() {
    let str = this.portalForm.get('LoginId').value;
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let chkEmail = re.test(str);
    return chkEmail;
  }

  addValidationsEmail() {
    this.portalForm.get('EmailId').setValidators([Validators.required, Validators.pattern(this.emailIdsPattern)])
    this.portalForm.updateValueAndValidity();
  }

  checkLoginOrEmailInList(loginOrEmail, fieldType, useExistingAccount) {
    if (loginOrEmail) {
      if (fieldType == 1) {
        let arr = this.portalLoginList.filter((ele) => ele.UserName.trim().toLowerCase() == loginOrEmail.trim().toLowerCase());
        if (arr.length) {
          this.isDuplicateEntry = true;
          this.isAddClicked = false;
        } else {
          this.isDuplicateEntry = false;
          if (this.isAddClicked) {
            this.savePortalItem();
          }
        }
      } else {
        let arr = this.portalLoginList.filter((ele) => ele.EmailId.trim().toLowerCase() == loginOrEmail.trim().toLowerCase());
        if (arr.length) {
          this.isDuplicateEntryEmailId = true;
          this.isAddClicked = false;
        } else {
          this.isDuplicateEntryEmailId = false;
          if (useExistingAccount) {
            this.showAddPopup();
            this.isAddClicked = false;
          } else {
            if (this.isAddClicked) {
              this.savePortalItem();
            }
          }
        }
      }
    } else {
      if (fieldType == 1) {
        this.isDuplicateEntry = false;
      } else {
        this.isDuplicateEntryEmailId = false;
      }
      if (this.isAddClicked) {
        this.savePortalItem();
      }
    }
    this.loaderIcon = Promise.resolve(false);
  }

  disableADD() {
    if (!this.portalForm.valid || (this.isValidEmail() && !this.portalForm.get('EmailId').value) || this.isDuplicateEntryEmailId || this.isDuplicateEntry) {
      return true;
    }
    return false;
  }

  updateWithExistingAccData() {
    this.portalForm.patchValue({
      FirstName: this.existingAccountInfo.FirstName ? this.existingAccountInfo.FirstName : (this.portalForm.get('FirstName').value ? this.portalForm.get('FirstName').value : this.customerName.firstName),
      LastName: this.existingAccountInfo.LastName ? this.existingAccountInfo.LastName : (this.portalForm.get('LastName').value ? this.portalForm.get('LastName').value : this.customerName.lastName),
      LoginId: this.existingAccountInfo.Username,
      CreatedDateTime: this.existingAccountInfo.CreatedDateTime
    });
    this.update = !this.existingAccountInfo.FirstName || !this.existingAccountInfo.LastName;
    this.disableForExisting = true;
    this.existingauthenticationId = this.existingAccountInfo.ObjectId;
    this.isDuplicateEntry = false;
    this.savePortalItem();
  }

  isBlurEmailCalled(fieldType) {
    let loginOrEmail = '';
    if (fieldType == 1) {
      loginOrEmail = this.portalForm.get('LoginId').value;
      if (loginOrEmail && loginOrEmail.trim() !== '') {
        this.isLoginExistsChecked = true;
      } else {
        this.isLoginExistsChecked = false;
        this.isDuplicateEntry = false;
      }
    } else {
      loginOrEmail = this.portalForm.get('EmailId').value;
      if (loginOrEmail && loginOrEmail.trim() !== '') {
        this.isEmailExistsChecked = true;
      } else {
        this.isEmailExistsChecked = false;
        this.isDuplicateEntryEmailId = false;
      }
    }
  }

  confirmResetPassword(user: any) {
    this.ConfirmationModal.show();
  }

  savePortalCallScript() {
    document.getElementById("portal-save-button").click();
  }

  cancelPortalCallScript() {
    document.getElementById("portal-close-button").click();
  }

  formatAsLocalString(dateValue: any): string {
  if (!dateValue) {
    return '';
  }

  if (!this.userSessionService.isCallcenterAgent) {
    const formattedValue =dateValue instanceof Date ? dateValue.toISOString() : String(dateValue);
    return formattedValue.replace('Z', '').split('+')[0].replace('T', ' ');
  }
  const localDate = new Date(dateValue);
  const yyyy = localDate.getFullYear();
  const mm = String(localDate.getMonth() + 1).padStart(2, '0');
  const dd = String(localDate.getDate()).padStart(2, '0');
  const hh = String(localDate.getHours()).padStart(2, '0');
  const min = String(localDate.getMinutes()).padStart(2, '0');
  const ss = String(localDate.getSeconds()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
}
}
